<template>
  <div class="sitios" style="background-color:#ffffff; border-radius: 20px;">

    <vue-element-loading :active="cargando" spinner="bar-fade-scale" color="#064dc3" size="120" :is-full-screen="true" text="Cargando..."/>
    <div class="form-row">
      <h1 class="col-8">Reporte de Entradas y Salidas a Sitios</h1>
      <div class="col-3"></div>
      <router-link to="/home">
        <b-button variant="outline-success" style="margin: 10px">
          <div class="h6 mb-1">
            <b-icon-arrow-left-square></b-icon-arrow-left-square>
          </div>
          <div style="font-size: 12px;">
            Inicio
          </div>
        </b-button>
      </router-link>
    </div>
    <div class="row">
      <div class="col-12">
        <label class="col-form-label">Unidades</label>
        <input
    class="filtro"
      v-model="searchUnidad"
      @input="handleSearch"
      placeholder="Filtrar..."
    />
        <multiselect
      ref="select"
      v-model="dispositivosSeleccionados"
      placeholder="Seleccione los dispositivos"
      label="name"
      track-by="id"
      :options="filteredUnidades"
      :multiple="true"
      :closeOnSelect="false"
      select-label="Seleccionar"
      deselect-label="Remover"
    >
    </multiselect>
        <button class="btn btn-sm btn-outline-primary mt-1" @click="selectAll" :disabled="selectDispositivoslDisabled">Select todo</button>
        <button class="btn btn-sm btn-outline-primary mt-1 ml-2" @click="removeAllUnidades" >Limpiar</button>
      </div>
      <div class="col-12">
        <label class="col-form-label">Grupos</label>
        <input
    class="filtro"
      v-model="searchTerm"
      @input="handleSearch"
      placeholder="Filtrar..."
    />
    <multiselect
      ref="select"
      v-model="gruposSeleccionados"
      placeholder="Seleccione los dispositivos"
      label="name"
      track-by="id"
      :options="filteredGrupos"
      :multiple="true"
      :closeOnSelect="false"
      select-label="Seleccionar"
      deselect-label="Remover"
    >
    </multiselect>
        <button class="btn btn-sm btn-outline-primary mt-1" @click="selectAllGrupos" :disabled="selectGruposDisabled">Select todo</button>
        <button class="btn btn-sm btn-outline-primary mt-1 ml-2" @click="removeAllGrupos">Limpiar</button>
      </div>
      <div class="col-12">
        <label class="col-form-label">Sitios</label>
        <label class="col-form-label">Grupos</label>
        <input
    class="filtro"
      v-model="searchSitio"
      @input="handleSearch"
      placeholder="Filtrar..."
    />
    <multiselect
      ref="select"
      v-model="geocercasSeleccionadas"
      placeholder="Seleccione los dispositivos"
      label="name"
      track-by="id"
      :options="filteredSitio"
      :multiple="true"
      :closeOnSelect="false"
      select-label="Seleccionar"
      deselect-label="Remover"
    >
    </multiselect>
        <button class="btn btn-sm btn-outline-primary mt-1" @click="selectGeocercasAll" :disabled="selectlGeocercaDisabled">Select todo</button>
        <button class="btn btn-sm btn-outline-primary mt-1 ml-2" @click="removeAllGeocercas">Limpiar</button>
      </div>
      <div class="col-md-4 mt-4">
        <input type="date" class="form-control" v-model="fechaInicio">
      </div>
      <div class="col-md-2 mt-4">
        <input type="time" class="form-control" v-model="horaInicio">
      </div>
      <div class="col-md-4 mt-4">
        <input type="date" class="form-control" v-model="fechaFin">
      </div>
      <div class="col-md-2 mt-4">
        <input type="time" class="form-control" v-model="horaFin">
      </div>
    </div>
    <button class="btn btn-sm btn-primary mt-3" @click="generarReporte()">Generar reporte</button>
    <button class="btn btn-sm btn-primary mt-3 ml-2" @click="exportExcel()">Exportar Excel</button>
    <button class="btn btn-sm btn-primary mt-3 ml-2" @click="exportCSV()">Exportar CSV</button>
    <div class="table-responsive mt-4">
      <table  class="table table-bordered table-hover text-center">
        <thead style="background-color: #05123C;">
          <tr class="text-white">
            <th>Unidad</th>            
            <th>Tipo de sitio</th>
            <th>Grupo</th>
            <th>Sitio</th>
            <th>Evento Entrada</th>
            <th>Fecha Entrada</th>
            <th>Evento Salida</th>
            <th>Fecha Salida</th>
            <!--<th>Hora del evento</th>-->
            <th>Tiempo en sitio</th>
            
            <!-- <th>Horas motor</th> -->
            <!-- <th>Combustible utilizado</th> -->
          </tr>
        </thead>
        <!--<tbody v-for="item of formatearDatos" v-if="item.type == 'geofenceEnter' && item.geofenceId == item2.id || item.type =='geofenceExit' && item.geofenceId == item2.id">-->
        <tbody v-for="item of formatearDatos.geofenceEnterAndExit" >
           
          <!--<tr v-for="item of formatearDatos" v-if="item.type == 'geofenceEnter' && item.geofenceId == $data.geocercasSeleccionadas[item.geofenceId] || item.type =='geofenceExit' && item.geofenceId == $data.geocercasSeleccionadas[item.geofenceId]">-->
            <tr>
            <td>{{ item.nombreUnidad }}</td>
            <td>{{item.tipoSitio}}</td>
            <td>{{item.grupo}}</td>
            <td>{{ item.sitio }}</td>
            <td>Entrada a Sitio</td>
            <td>{{item.fechaEntrada}}</td>
          
            <td>Salida de Sitio</td>
            
            <td>{{item.fechaSalida}}</td>
            <td>{{item.duration}}</td>
           
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>
<script>

import { mapState, mapMutations, mapActions } from "vuex";
//import {mostrarMensajeErrorCatch, mostrarMensajeInformativo, mostrarMensajeExitoso, mostrarMensajeError} from '../../mixins/mensajes';

export default {
  data() {
    return {
      dispositivosObtenidos: [],
      dispositivosSeleccionados: [],
      dispositivosSeleccionados2: [],
      gruposObtenidos: [],
      gruposSeleccionados: [],
      gruposSeleccionados2: [],
      geocercasObtenidas: [],
      geocercasSeleccionadas: [],
      geocercasSeleccionadas2: [],
      fechaInicio: '',
      horaInicio: '00:00',
      fechaFin: '',
      horaFin: '00:00',
      datosReporte: [],
      searchTerm: '',
      searchUnidad: '',
      searchSitio: '',
      selectDispositivoslDisabled: false,
      selectGruposDisabled: false,
      selectlGeocercaDisabled: false,
      selectBolDispositivos: false,
      selectBolGrupos: false,
      selectBolGeocerca: false,
      borroBolDispositivos: false,
      borroBolGrupos: false,
      borroBolGeocerca: false,
      
    }
  },
  watch: {
    dispositivosSeleccionados(newSelected) {
  
     
      this.dispositivosSeleccionados = newSelected;
     
    },
    gruposSeleccionados(newSelected) {
  
     
  this.gruposSeleccionados = newSelected;

},

geocercasSeleccionadas(newSelected) {
  
     
  this.geocercasSeleccionadas = newSelected;
  
}
  },

  computed: {
    ...mapState({
      catUnidades: state => state.catalogos.catUnidades,
      catGeocercas: state => state.catalogos.catGeocercas
    }),

    ...mapState(["cargando"]),

    formatearIds() {
      //let data = '';
      var index = 0;
      this.dispositivosSeleccionados2 = [];
      for (let item of this.dispositivosSeleccionados) {
      
        this.dispositivosSeleccionados2.push(item.id);
        index++;
      }
      return this.dispositivosSeleccionados2;
    },
    filteredGrupos() {
      return this.gruposObtenidos.filter(option => {
        if(this.searchTerm!=''){
          this.borroBolGrupos= true;
          this.selectGruposDisabled = false;
        }else if(this.borroBolGrupos){
          this.borroBolGrupos= false;
          this.selectGruposDisabled = true;
        }
       
        return option.name.toLowerCase().includes(this.searchTerm.toLowerCase());
      });
    },
    filteredUnidades() {
      
       
      
      return this.dispositivosObtenidos.filter(option => {
        if(this.searchUnidad!=''){
          this.borroBolDispositivos= true;
          this.selectDispositivoslDisabled = false;
        }else if(this.borroBolDispositivos){
          this.borroBolDispositivos= false;
          this.selectGruposDisabled = true;
        }
        return option.name.toLowerCase().includes(this.searchUnidad.toLowerCase());
      });
    },
    filteredSitio() {
     
      return this.geocercasObtenidas.filter(option => {
        if(this.searchSitio!=''){
          this.borroBolGeocerca= true;
          this.selectlGeocercaDisabled = false;
        }if(this.borroBolGeocerca){
          this.borroBolGeocerca= false;
          this.selectGruposDisabled = true;
        }
        return option.name.toLowerCase().includes(this.searchSitio.toLowerCase());
      });
    },
    formatearIdGrupo() {
       var index = 0;
       this.gruposSeleccionados2= [];
      for (let item of this.gruposSeleccionados) {
        this.gruposSeleccionados2.push(item.id);
        index++;
      }
      return this.gruposSeleccionados2;
    },

    
    formatearIdGeocerca() {
       var index = 0;
       this.geocercasSeleccionadas2= [];
      for (let item of this.geocercasSeleccionadas) {
        this.geocercasSeleccionadas2.push(item.id);
        index++;
      }
      
      return this.geocercasSeleccionadas2;
    },

     formatearDatos() {
      
      const array = Array.from(Object.values(this.datosReporte));
      //console.log(array);
          
     return this.datosReporte;
                       
      
    }
  },

  methods: {
    ...mapActions("catalogos", ["obtenerUnidades"],["obtenerGeocercas"]),
    ...mapMutations(["setearCargando"]),


    

    handleSearch() {
      // Puedes agregar lógica adicional aquí si es necesario
    },
    obtenerSesion() {
      let params = new URLSearchParams();
      params.append("email", "desarrollo.gps@busmen.com");
      params.append("password", "12345");
      let headers = { headers: { "Content-Type": "application/x-www-form-urlencoded" } };

      axios.post(`${url}session`, params, JSON.parse(localStorage.user))
        .then(response => {
          console.log("Sesion");
        })
        .catch(error => {
          console.log("No sesion");
        });
    },

    generarReporte() {
     
      if (this.fechaInicio !='' & this.fechaFin.length !='' || this.geocercasSeleccionadas!=''|| this.gruposSeleccionados!='') {
        let fechaInicio = encodeURIComponent( new Date(this.fechaInicio + ' ' + this.horaInicio).toISOString() );
        let fechaFin = encodeURIComponent( new Date(this.fechaFin + ' ' + this.horaFin).toISOString());
        console.log("sf");
        this.setearCargando(true);
        this.reporteGeocercas(this.fechaInicio, this.horaInicio,this.fechaFin,this.horaFin);
        /*if (this.gruposSeleccionados.length) {
          this.reporteGeocercasGrupos(fechaInicio, fechaFin);
        }else{
          this.reporteGeocercas(fechaInicio, fechaFin);
        }*/
      }
      else if (this.fechaInicio =='' & this.fechaFin.length =='' & this.geocercasSeleccionadas.length =='' & this.gruposSeleccionados == '' & this.dispositivosSeleccionados == '')
      {
        alert('Debe seleccionar las fechas, sitio y unidades');
      }
       else if (this.geocercasSeleccionadas.length !='' & this.fechaInicio ==''  & this.fechaFin.length =='' & this.gruposSeleccionados == '' & this.dispositivosSeleccionados == '')
      {
        alert('Debe seleccionar las fechas y unidades');
      }
      else if (this.geocercasSeleccionadas.length !='' & this.fechaInicio ==''  & this.fechaFin.length =='' & this.gruposSeleccionados != '' || this.dispositivosSeleccionados != '' & this.geocercasSeleccionadas.length !='' & this.fechaInicio ==''  & this.fechaFin.length =='')
      {
        alert('Debe seleccionar las fechas');
      }
      
      else if (this.fechaInicio !='' & this.fechaFin.length !='' & this.geocercasSeleccionadas.length=='' & this.gruposSeleccionados == '' ||  this.fechaInicio !='' & this.fechaFin.length !='' & this.geocercasSeleccionadas.length=='' & this.dispositivosSeleccionados == '')
      {
        alert('Debe seleccionar el sitio y las unidades');
      }
      else if (this.fechaInicio =='' & this.fechaFin.length =='' & this.geocercasSeleccionadas.length=='' & this.gruposSeleccionados != '' ||  this.fechaInicio =='' & this.fechaFin.length =='' & this.geocercasSeleccionadas.length=='' & this.dispositivosSeleccionados != '')
      {
        alert('Debe seleccionar el sitio y las unidades');
      }
    },
   
    reporteDispositivos(fechaInicio, fechaFin){
     
      axios.get(`${url}reports/summary?${this.formatearIds}&from=${fechaInicio}&to=${fechaFin}` , JSON.parse(localStorage.user))
        .then(response => {
          this.datosReporte = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          alert('Ha ocurrido un error');
          this.setearCargando(false);
        });
    },
    
    async reporteGeocercas(fechaInicio, horaInicio, fechaFin, horaFin) {
  try {
   
    const baseUrl = 'https://apiscombustible.geovoy.com:8000/api/reporte_entradas_salidas_format';

    const queryParams = new URLSearchParams({
      fecha_inicial: fechaInicio,
      hora_inicial: horaInicio,
      fecha_final: fechaFin,
      hora_final: horaFin,
    });

    const url = `${baseUrl}?${queryParams.toString()}`;

    const bodyData = {
      "deviceid": this.formatearIds,
      "geofenceid": this.formatearIdGeocerca,
      "groupid": this.formatearIdGrupo
    };

    const response = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(bodyData),
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const responseData = await response.json();
    this.datosReporte = responseData;
    console.log(this.datosReporte);
    this.setearCargando(false);
  } catch (error) {
    console.error('Ha ocurrido un error:', error);
    alert('Ha ocurrido un error');
    this.setearCargando(false);
  }
}

,
    
     reporteGeocercasGrupos(fechaInicio, fechaFin){
      axios.get(`${url}reports/events?${this.formatearIdGrupo}&from=${fechaInicio}&to=${fechaFin}` , JSON.parse(localStorage.user))
        .then(response => {
          this.datosReporte = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          alert('Ha ocurrido un error');
          this.setearCargando(false);
        });
    },

    reporteGrupos(fechaInicio, fechaFin){
      axios.get(`${url}reports/summary?${this.formatearIdGrupo}&from=${fechaInicio}&to=${fechaFin}` , JSON.parse(localStorage.user))
        .then(response => {
          this.datosReporte = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          this.setearCargando(false);
          alert('Ha ocurrido un error');
        });
    },

    selectAll() {
      this.dispositivosSeleccionados = [];
      for (let item of this.filteredUnidades) {
          this.dispositivosSeleccionados.push(item);
      }
      
      this.selectGruposDisabled = true;
      this.selectDispositivoslDisabled= true;
      this.selectlGeocercaDisabled = true;
      this.selectBolDispositivos = true;
    },
    
    selectAllGrupos() {
      this.gruposSeleccionados = [];
      for (let item of this.filteredGrupos) {
          this.gruposSeleccionados.push(item);
      }
      
      this.selectGruposDisabled = true;
      this.selectDispositivoslDisabled= true;
      this.selectlGeocercaDisabled = true;
      this.selectBolGrupos = true;
    },
    
    selectGeocercasAll() {
      this.geocercasSeleccionadas = [];
      for (let item of this.filteredSitio) {
          this.geocercasSeleccionadas.push(item);
      }
      this.selectGruposDisabled = true;
      this.selectDispositivoslDisabled= true;
      this.selectlGeocercaDisabled = true;
      this.selectBolGeocerca = true;
    },

   
    removeAll() {
      this.dispositivosSeleccionados = [];
      this.dispositivosSeleccionados2 = [];
      this.gruposSeleccionados = [];
      this.gruposSeleccionados2 = []; 
      this.geocercasSeleccionadas = [];         
      this.geocercasSeleccionadas2 = []; 

    },
    
    removeAllGrupos() {
      this.gruposSeleccionados = [];
      this.gruposSeleccionados2 = [];
      if(this.selectBolGrupos&&!this.selectBolDispositivos&&!this.selectBolGeocerca){

        this.selectGruposDisabled = false;
      this.selectDispositivoslDisabled= false;
      this.selectlGeocercaDisabled = false;
      
      }
      this.selectBolGrupos = false;
    },
    removeAllUnidades() {
      this.dispositivosSeleccionados = [];
      this.dispositivosSeleccionados2 = [];
      if(!this.selectBolGrupos&&this.selectBolDispositivos&&!this.selectBolGeocerca){

        this.selectGruposDisabled = false;
      this.selectDispositivoslDisabled= false;
      this.selectlGeocercaDisabled = false;
     

        }
        this.selectBolDispositivos = false;
    },
    removeAllGeocercas() {
      this.geocercasSeleccionadas = [];         
      this.geocercasSeleccionadas2 = []; 
      if(!this.selectBolGrupos&&!this.selectBolDispositivos&&this.selectBolGeocerca){

        this.selectGruposDisabled = false;
      this.selectDispositivoslDisabled= false;
      this.selectlGeocercaDisabled = false;
       

        }
        this.selectBolGeocerca = false;
    },

    exportExcel() {
			if(this.datosReporte){
        let data = XLSX.utils.json_to_sheet(this.datosReporte.geofenceEnterAndExit, { header: ['nombreUnidad', 'tipoSitio', 'sitio'] } );
        data['A1'].v = 'Unidad';
        data['B1'].v = 'Tipo de Sitio';
        data['C1'].v = 'Sitio';
        
       

				const workbook = XLSX.utils.book_new();
				const filename = 'Reporte';
				XLSX.utils.book_append_sheet(workbook, data, filename);
     //   XLSX.writeFile(workbook, `${filename}${this.fechaInicio} ${this.horaInicio} - ${this.fechaFin} ${this.horaFin}.csv`);
        XLSX.writeFile(workbook, `${filename}${this.fechaInicio} ${this.horaInicio} - ${this.fechaFin} ${this.horaFin}.xlsx`);
			}
			else{
				alert('Ha ocurrido un error');
      }
    },
    exportCSV() {
			if(this.datosReporte){
        let data = XLSX.utils.json_to_sheet(this.datosReporte.geofenceEnterAndExit, { header: ['nombreUnidad', 'tipoSitio', 'sitio'] } );
        data['A1'].v = 'Unidad';
        data['B1'].v = 'Tipo de Sitio';
        data['C1'].v = 'Sitio';
        
        //data['F1'].v = 'Hora';
        //data['G1'].v = 'odometroFinal';

				const workbook = XLSX.utils.book_new();
				const filename = 'Reporte';
				XLSX.utils.book_append_sheet(workbook, data, filename);
        XLSX.writeFile(workbook, `${filename}${this.fechaInicio} ${this.horaInicio} - ${this.fechaFin} ${this.horaFin}.csv`);
       // XLSX.writeFile(workbook, `${filename}${this.fechaInicio} ${this.horaInicio} - ${this.fechaFin} ${this.horaFin}.xlsx`);
			}
			else{
				alert('Ha ocurrido un error');
      }
    },

    obtenerDispositivos() {
      this.setearCargando(true);
      axios.get(`${url}devices`, JSON.parse(localStorage.user))
        .then(response => {
          this.dispositivosObtenidos = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          this.setearCargando(false);
          alert('Ha ocurrido un error');
        });
    },

    obtenerGrupos() {
      this.setearCargando(true);
      axios.get(`${url}groups`, JSON.parse(localStorage.user))
        .then(response => {
          this.gruposObtenidos = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          this.setearCargando(false);
          alert('Ha ocurrido un error');

        });
    },
    
     obtenerGeocercas() {
      this.setearCargando(true);
      axios.get(`${url}geofences`, JSON.parse(localStorage.user))
        .then(response => {
          this.geocercasObtenidas = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          this.setearCargando(false);
          alert('Ha ocurrido un error');

        });
    },
  },

  created() {
    this.obtenerDispositivos();
    this.obtenerGrupos();
    this.obtenerGeocercas();
    // this.obtenerUnidades();
    // this.obtenerSesion();
  },

  mounted() {
    // this.obtenerKilometraje();
    if (sessionStorage.aleatorio != 1379248){
    this.$router.push({name: "/" });
  }
  }
}
</script>
<style>
  .sitios{
    margin: 50px;
    margin-bottom:1%;
    padding-right: 15px;
    padding-left: 15px;
    padding-bottom: 15px;
    padding-top:15px;
  }
  .filtro{
    
    
    display: block;
    padding: 8px 9px 8px 8px;
    margin-bottom: 5px;
    border-radius: 5px;
    border: 1px solid #e8e8e8;
    background: #fff;
    font-size: 14px;
    
    
   
  }
</style>